// extracted by mini-css-extract-plugin
export default {"menu-view__title":"s_bG my-2 p-2","menu-view__tile-row":"s_bH d-flex"};